import React from 'react'
import image from '../../../assets/logos/validando_cuenta.png'
import { useTranslation } from "react-i18next"
import { Grid, useMediaQuery } from '@material-ui/core'
import './verify-contract.css'

const VerifyContract = (props) => {
  const { t } = useTranslation()
  const longmatches = useMediaQuery('(max-width:768px)')

  console.log(props.contractStatus)
  const imageContainer = {
    display: 'block',
    margin: 'auto'
  }
  if (longmatches) {
    imageContainer.display = 'none'
  }

  return (
    <div className="contariner-contract">
      {longmatches ?
        <div className='text-active-plan'>
          <h4 className='text-pay'>{t('verify.titlePayVerify')}</h4>
          <span>{props.contractStatus === 4 ? t('verify.textPlanVerifyExpired') : t('verify.textPlanVerifyNew')}</span>
        </div>
        :
        <div style={imageContainer}>
          <img className='verify-contract-image ' alt='' src={image} />
          <p className='verify-contract-subtext'>{props.contractStatus === 4 ? t('verify.textPlanVerifyExpired') : t('verify.textPlanVerifyNew')}</p>
        </div>
      }

    </div>
  )
}
export { VerifyContract as default }